import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { accountInfoModel } from "../models/serviceResponse.model";
import { AccountDisplayTypes } from "../module-config/module-config";

interface AccountAbstractRouter{
    toChangePin():unknown
    toChangePinWithParams<T>(params:T):unknown
    toChangeEmail(accountInfo:accountInfoModel):unknown
    toChangePhoneNumber(accountInfo:accountInfoModel):unknown
    toChangeProfile(accountInfo:accountInfoModel):unknown
    toMyAccount():unknown
    toProfile(accountInfo:accountInfoModel):unknown
    toRegister():unknown
    toLogin():unknown
    toLoginWithParams<T>(params:T):unknown
}

export class AccountRouterManager implements AccountAbstractRouter{
    private accountRouter!:AccountAbstractRouter;

    constructor(private router:Router){

    }

    setRouterConfig(config:AccountDisplayTypes){
        if(config === 'side-menu'){
            this.accountRouter = new AccountSideMenuRouter(this.router);
        }else if(config === 'main-menu'){
            this.accountRouter = new AccountMainMenuRouter(this.router);
        }else{
            throw new Error('no router found!');
        }
    }

    toChangePin(){
        this.accountRouter.toChangePin();
    }

    toChangePinWithParams<T>(params:T){
        this.accountRouter.toChangePinWithParams(params);
    }

    toChangeEmail(accountInfo:accountInfoModel){
        this.accountRouter.toChangeEmail(accountInfo);
    }

    toChangePhoneNumber(accountInfo:accountInfoModel){
        this.accountRouter.toChangePhoneNumber(accountInfo);
    }

    toChangeProfile(accountInfo:accountInfoModel){
        this.accountRouter.toChangeProfile(accountInfo);
    }

    toMyAccount(){
        this.accountRouter.toMyAccount();
    }

    toProfile(accountInfo:accountInfoModel){
        this.accountRouter.toProfile(accountInfo);
    }

    toRegister(){
        this.accountRouter.toRegister();
    }

    toLogin(){
        this.accountRouter.toLogin();
    }

    toLoginWithParams<T>(params:T){
        this.accountRouter.toLoginWithParams(params);
    }
}

export class AccountMainMenuRouter implements AccountAbstractRouter{

    constructor(private router:Router){}

    toChangePin(){
        this.router.navigate(['account/changePin']);
    }

    toChangePinWithParams<T>(params:T){
        this.router.navigate(['account/changePin'],{state: {accountInfo: params}});
    }

    toChangeEmail(accountInfo:accountInfoModel){
        this.router.navigate(['account/changeEmail'], {state: {type: 'email', accountInfo: accountInfo}});
    }

    toChangePhoneNumber(accountInfo:accountInfoModel){
        this.router.navigate(['account/changeEmail'], {state: {type: 'phone', accountInfo: accountInfo}});
    }

    toChangeProfile(accountInfo:accountInfoModel){
        this.router.navigate(['account/changeProfile'], {state: {accountInfo: accountInfo}});
    }

    toMyAccount(){
        this.router.navigate(['account']);
    }

    toProfile(accountInfo:accountInfoModel){
        this.router.navigate(['account/profile'], {state: {accountInfo: accountInfo}});
    }

    toRegister(){
        this.router.navigate(['account/register']);
    }

    toLogin(){
        this.router.navigate(['account/login']);
    }

    toLoginWithParams<T>(params:T){
        this.router.navigate(['account/login'], {state: {accountInfo: params}});
    }
}

export class AccountSideMenuRouter implements AccountAbstractRouter{

    constructor(private router:Router){}

    toChangePin(){
        this.router.navigate(['home', {outlets: { account: ['changePin']}}], {skipLocationChange:true})
    }

    toChangePinWithParams<T>(params:T){
        this.router.navigate(['home',{outlets: { account: ['changePin']}}], {state: {accountInfo: params}, skipLocationChange:true});
    }

    toChangeEmail(accountInfo:accountInfoModel){
        this.router.navigate(['home', {outlets: { account: ['changeEmail']}}], 
            {state: {type: 'email', accountInfo: accountInfo}, skipLocationChange:true}
        )
    }

    toChangePhoneNumber(accountInfo:accountInfoModel){
        this.router.navigate(['home', {outlets: { account: ['changeEmail']}}], 
            {state: {type: 'phone', accountInfo: accountInfo}, skipLocationChange:true}
        )
    }

    toChangeProfile(accountInfo:accountInfoModel){
        this.router.navigate(['home', {outlets: {account: ['changeProfile']}}], {state: {accountInfo: accountInfo}, skipLocationChange:true})
    }

    toMyAccount(){
        this.router.navigate(['home', {outlets: { account: [null]}}], {skipLocationChange:true})
    }

    toProfile(accountInfo:accountInfoModel){
        this.router.navigate(['home', {outlets: { account: ['profile']}}], 
            {state: {accountInfo: accountInfo}, skipLocationChange:true}
        )
    }

    toRegister(){
        this.router.navigate(['home', {outlets: { account: ['register']}}], {skipLocationChange:true});
    }

    toLogin(){
        this.router.navigate(['home',{outlets: { account: ['login']}}], {skipLocationChange:true})
    }

    toLoginWithParams<T>(params:T){
        this.router.navigate(['home',{outlets: { account: ['login']}}], {state: {accountInfo: params}, skipLocationChange:true})
    }
}